import React from "react";
import { LoadingIndicator } from "@sainsburys-tech/fable";

const LoadingIndicatorOverlay = () => (
  <div className="cb-c-loading-indicator-overlay">
    <div className="fable:relative">
      <LoadingIndicator isLoading shouldPreventFocus isStandalone size="lg"/>
    </div>
  </div>
);

export default LoadingIndicatorOverlay;
